import { render, staticRenderFns } from "./card-video.vue?vue&type=template&id=7194a828&scoped=true"
import script from "./card-video.vue?vue&type=script&lang=js"
export * from "./card-video.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7194a828",
  null
  
)

export default component.exports